import { Grid, Typography } from '@mui/material';
import Observer from '../../shared/Observer/Observer';
import ContentTitle from '../../layout/ContentTitle/ContentTitle';
import { PAGE } from '../../../constants/page';
import ArrowButton from '../../ui/ArrowButton/ArrowButton';

interface Props {
  children?: React.ReactElement<unknown>;
}

const texts = [
  "サプライムは様々な業界や企業の課題を",
  "一緒に解決できる仲間を募集しています。",
  "私たちと一緒に未来の社会に貢献しませんか？"
]

export default function RecruitSection(props: Props) {
  return (
    <>
      <Grid container>
        <Grid size={{ xs: 12, md: 12 }}>
          <Observer>
            <ContentTitle title={PAGE.RECRUIT.NAME} subTitle={PAGE.RECRUIT.TEXT} />
          </Observer>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }} sx={{ margin: '5rem 0', padding: '1.5rem' }}>
          {texts.map((t, index) => {
            return (
              <Observer key={index} timeout={(index + 1) * 100}>
                <Typography
                  variant="body2"
                  sx={(theme) => ({
                    [theme.breakpoints.up('xs')]: {
                      fontSize: '1.1rem',
                    },
                    [theme.breakpoints.up('sm')]: {
                      fontSize: '1.2rem',
                    },
                    [theme.breakpoints.up('md')]: {
                      fontSize: '1.25rem',
                    },
                    [theme.breakpoints.up('lg')]: {
                      fontSize: '1.5rem',
                    },
                  })}
                >
                  {t}
                </Typography>
              </Observer>
            )
          })}
        </Grid>
      </Grid>

      <Grid size={{ sm: 12, lg: 12 }} sx={{ textAlign: 'right', padding: '1rem' }}>
        <Observer timeout={3 * 500}>
          <ArrowButton label="MORE" href={PAGE.RECRUIT.PATH} />
        </Observer>
      </Grid>
    </>
  )
}